import React from "react";
import styles from "./whyChooseUs.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCode, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";

const WhyChooseUs: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className="sectionTitle">
                    {/*{String(t('homePage.whyUsTitle'))}*/}
                    What Makes Us Different
                </h1>
            </LazyText>

            <LazyText>
                <h3 className={styles.services_message}>
                    We bring tech closer to our community with transparent,
                    fair pricing and powerful solutions designed to transform your business.
                </h3>
            </LazyText>

            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        {/*{String(t('homePage.whyChooseUs.whyChooseUsTitle1'))}*/}
                        understanding your needs and goals
                    </div>
                    <div className={styles.icon_container}>
                        01
                    </div>
                    <div className={styles.content}>
                        <p>
                            Understanding the problem is half of the solution, we put great emphasis
                            on solving the right problems.

                        </p>
                    </div>
                </div>

                <div className={styles.card}>
                    <div className={styles.card_title}>
                        Customer obsession
                    </div>
                    <div className={styles.icon_container}>
                        02
                    </div>
                    <div className={styles.content}>
                        <p>
                            We obsess over your experience, your needs, and your success
                            because your business truly matters to us.
                        </p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        integrity and transparency
                    </div>
                    <div className={styles.icon_container}>
                        03
                    </div>
                    <div className={styles.content}>
                        <p>
                            Honest, clear, committed. No surprises ever. That’s how we do business.
                        </p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        Ethical excellence
                    </div>
                    <div className={styles.icon_container}>
                        04
                    </div>
                    <div className={styles.content}>
                        <p>
                            We make it right, with integrity you can trust. That’s excellence to us.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
